import { Injectable } from "@angular/core";
import { FilterService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class CustomFiltersHelper {
  constructor(private filterService: FilterService
  ) { }

  betweenFilterRegister() {
    this.filterService.register('between', (value, filter: any): boolean => {
      if (filter === undefined || filter === null || filter === '') {
        return true;
      }
      if (filter.length === 2 && filter[0] && filter[1]) {

        if (value === undefined || value === null || value === '') {
          return false;
        }
        const [s, e] = filter;
        const parsedValue = value instanceof Date ? value : new Date(value);
        if (Number.isNaN(parsedValue.getTime())) {
          return false;
        }
        return parsedValue >= s && parsedValue <= e;
      }
      else
        return false;
    });
  }
}
